export default function CertCallout({ caption, marks, label }) {
  return (
    <aside className="cert-callout" aria-label={label ?? (typeof caption === 'string' ? caption : undefined)}>
      <div className="cert-callout-marks">
        {marks.map((mark) => (
          <img key={mark.name} src={mark.src} alt={mark.name} loading="lazy" decoding="async" />
        ))}
      </div>
      <p className="cert-callout-caption">{caption}</p>
    </aside>
  );
}
